import { keepPreviousData, useInfiniteQuery, useQuery } from "@tanstack/react-query";
import NetInfo from '@react-native-community/netinfo';
import { QueryKeys } from './QueryKeys';
import { getAddresses, getLoggedInUserInfo, getPeople, getPeopleWithConversationAccess, getPersonCustomFieldSections, getPersonCustomFields, getPersonProfile, getPersonBasic, getProtectedPersonFields, getPersonForMerge, getPotentialDuplicates, findPeopleByName, getPersonCustomField, getAddress, getPersonCustomFieldSection, assignPermissions } from "../../data/people";
import { getCustomFieldSections, getCustomFields, getCustomField, getCustomFieldSection } from "../../data/customFields";
import { getQuickFilters } from "../../data/quickFilters";
import { getProfileView, getProfileViewCard, getProfileViews } from "../../data/profileViews";
import { getPermission, getPermissions, getRole, getRoleFolder, getRoles, getRolesInFolders } from "../../data/roles";
import { getTask, getTaskAssignmentTemplate, getTaskAssignmentTemplates, getTaskInstance, getVolunteerTeam, getVolunteerTeams, getTasks, getRecentAssigneesForTask, getRecentAssigneesForTasks, upcomingTaskInstancesAsAssigner, upcomingTaskInstancesForPerson, upcomingTaskInstancesForTeam, getIndividualTaskInstances, getPersonTaskHistory } from "../../data/tasks";
import { getLocation, getLocations } from "../../data/locations";
import { getCalendar, getCalendars } from "../../data/calendars";
import { getBoard, getBoardMembers, getBoards, getAllOrgBoards, getCommentsForPost, getConversation, getConversations, getAllOrgConversations, getGifs, getMessagesForConversation, getMyBoardsFeed, getPost, getPostsForBoard, getPostViewers } from "../../data/connect";
import { getAttendance, getBlackoutDates, getBlackoutDatesForMonth, getEventCustomFieldSections, getEventCustomFields, getEventInstance, getEvents, getEvent, getPrintLabels, getRecentAttendance, getPersonAttendanceHistory, getEventCustomFieldSection, getEventAnalytics, getEventUniqueAttendees, getEventUniqueAttendeesDetail, getPastEventInstances, getEventInstancesByEventID, getEventInstancesForRegistration, getEventInstancesForDate, getUpcomingEventInstancesWithTasks, getEventForMerge, getEventRegistrants, getEventRegistrantCodes, getEventRegistrantPaths, getRegistrantPathEnrollments, getRegistrantDetail, getPendingEventRegistrants, getEventRegistrationExtensions, getEventRegistrationExtensionSource, getPublicJesusTentRevivalStats } from "../../data/events";
import { getSong, getSongs } from "../../data/songs";
import { getRegisteredUsers, getRegistrations, getRegistrationsByRequestingUser, getInvites, getInvitesForUser } from "../../data/registrations";
import { getActivity, getImportAssociations, getImportTemplates, getOrganization, getOrganizationEntitlements, getUsersOrganizations, globalSearch, getQuickPersonFields, getCachedOrgID } from "../../data/organization";
import { getGivingMerchant, getPaymentMethods, getRecurringGifts, getOrgRecurringGifts, getReportSession } from "../../data/giving";
import { getBillingInfo } from "../../data/billing";
import { getLink, getLinks } from "../../data/library";
import { getDevices, getNotificationTypes, getDashboardSections, getDashboardData } from "../../data/settings";
import { getApiKeys } from "../../data/apiKeys";
import { queryClient } from "../../data/client";
import { getAttendanceDateFieldsKPIs, getAttendanceFirstFouthTimeVisitorsKPIs, getAttendanceFirstFouthTimeVisitorsDetail, getAttendanceUniqueKPIs, getAttendanceUniqueDetail, getBirthdayReport, getMissedReport, getAttendanceWeeklyUniqueAvgKPIs, getVolunteerUtilization } from "../../data/reports";
import { getSmallGroup, getSmallGroupMetrics, getSmallGroups, getSmallGroupsForDropdown, getSmallGroupSession, getSmallGroupTrends, getSmallGroupTypes, getSmallGroupType, getSmallGroupReportingStats, getSmallGroupDateStats, getSmallGroupTeachersDetail, getSmallGroupStudentsDetail, getActiveGroupsDetail, getActiveLeadersDetail, getActiveStudentsDetail, getSessionsDetail, getNewGroupsDetail, getCompletedGroupsDetail, getSmallGroupLeaderReport, getSmallGroupSessionsPaginated, getSmallGroupForMerge } from "../../data/smallGroups";
import { getBibleStudies, getBibleStudySessions, getBibleStudyStudents, getBibleStudySessionNotes, getBibleStudyPeopleNotes, bibleStudyTeacherDetail, bibleStudyStudentOutcomes } from "../../data/bibleStudies";
import { getBatch, getBatches, getBatchTransactions, getBatchStats, getFund, getFunds, getMethod, getMethods, getTransaction, getTransactionsByPerson, getContributionsAnalytics, getContributionsKPIs, getContributionsByMonth, getTopGivers, getGivingByMethod, getGivingByFund, getContributionYears } from "@/data/contributions";
import { getShortcuts, getRecentShortcuts } from "@/data/shortcuts";
import { getTrainingModules, getTrainingModule, getClassInstance, getTrainingClassInstanceByTaskInstanceID, getTrainingOverviewStats, getTrainingModuleStats, getUpcomingTrainingClasses, getPersonTrainingProgress, getTrainingTerms } from "@/data/training";
import { getPaths, getPathsForFormTrigger, getPathsForEventCheckInTrigger, getEventsForCheckInPath, getPathsForManualTrigger, getPath, getPathEnrollments, getPersonPathEnrollments, fetchPathVariables, getEnrollmentContextByTaskInstance } from "@/data/paths";
import { getAutomationTriggerCatalog, fetchAutomationVariables } from "@/data/automations";
import { getForms, getForm, getFormEntries, getFormEntry, getFormsTriggeringPath, getFormFolders, getMyFormEntries, hasEditableForms } from "@/data/forms";
import { getEmailTemplates, getEmailTemplate, getEmailCampaigns, getEmailCampaignRecipients, getEmailDeliveryStatuses } from "@/data/emails";
import { getSMSCampaigns, getSMSCampaignRecipients } from "@/data/sms";
import { getRootFolder, getFolderContents, searchFiles, getFolderBreadcrumbs, getFolderTree, getOrgStorageUsage } from "@/data/files";
import { getNotesByPersonID } from "@/data/notes";
import { getActivityFeed } from "@/data/activity";
import { getMaintenanceStatus } from "@/data/maintenance";
import {
    getServiceFlowTemplates,
    getServiceFlowTemplate,
    getEventServiceFlowAttachment,
    getServiceFlowInstance,
    getServiceFlowForInstance,
} from "@/data/serviceFlows";
import { SERVICE_FLOW_LIMITS } from '@/config/serviceFlows';

const SERVICE_FLOW_STALE_TIME = SERVICE_FLOW_LIMITS.staleTimeMs;
import { getAssistantMessages, getAssistantSessions } from "@/data/assistant";
import { getAutoScheduleStatus, fetchAutoScheduleExclusions, AUTO_SCHEDULE_ACTIVE_STATUSES } from "@/data/taskAutoSchedule";
import { getGuideState } from '@/data/guides';
import { getFollowUpPerson, getMyFollowUpPeople, getFollowUpPersonNotes, getFollowUpTaskContext, getFollowUpPersonTasks, listFollowUpNeedsOwner, getFollowUpOverview, listFollowUpPeople, getMyFollowUp, listFollowUpAudiences, listFollowUpPaths, getFollowUpPath, listFollowUpEnrollments, getFollowUpEnrollment, getFollowUpCareEpisode, listFollowUpCareEpisodes, getFollowUpPersonActiveCareEpisode, closeFollowUpCare } from '@/data/followUp';
import { getAnnouncementSettings, getAnnouncements, getAnnouncementReport } from '@/data/announcements';
import { getMilestoneCatalog, listMilestoneDefinitions, getMilestoneDefinition, getPersonMilestoneState, getOrganizationMilestoneHistory, getOwnMilestoneCelebrationState } from '@/data/milestones';
import { MILESTONES_ENABLED, MILESTONE_PRESENTATION } from '@/config/milestones';
import { isFreeOrg } from '@/utils/organizationEntitlements';
import Toast from "react-native-toast-message";

let isConnected = true;
NetInfo.addEventListener(state => {
    isConnected = state.isConnected !== false;
});

/**
 * Checks if an error is a Supabase network error that should be retried.
 * @param {Error} error - The error to check.
 * @returns {boolean} - True if the error is a retryable network error.
 */
export const isSupabaseNetworkError = (error) => {
    if (!error) return false;
    
    const errorMessage = error?.message?.toLowerCase() || '';
    
    const networkErrorPatterns = [
        'network',
        'fetch',
        'networkerror',
        'connection',
        'timed out',
        'timeout',
        'load failed', //Weird safari error, usually resolves after a couple retries
        // Request-queue backpressure rejection (requestQueue.js) — retries
        // once the queue drains (CHURCH-APP-1F6/14J).
        'request queue is full',
    ];
    
    return networkErrorPatterns.some(pattern => 
        errorMessage.includes(pattern)
    );
};

/**
 * Custom retry function for react-query that handles Supabase network errors.
 * Retries up to 4 times with exponential backoff, but only if device is online.
 * @param {number} failureCount - Number of times the query has failed.
 * @param {Error} error - The error that caused the failure.
 * @returns {boolean} - True if the query should be retried.
 */
export const shouldRetryQuery = (failureCount, error) => {
    if(__DEV__) console.log("Query Failure, checking retry:", failureCount, error);

    if(!isSupabaseNetworkError(error)) {
        return false;
    }

    if (failureCount >= 4) {
        Toast.show({
            type:"network", 
            props: {disconnected: true},
            text1: "Network Error",
            text2: "Unable to connect after several attempts. You may have an unstable connection, or the server could be down. Please try again later!"
        });
        return false;
    }
    
    if (!isConnected){
        Toast.show({
            type:"network", 
            props: {disconnected: true},
            text1: "Network Error",
            text2: "Looks like you're not connected to the internet. Please check your connection and try again!"
        });

        return false;
    }
    
    return true;
};

/**
 * Calculates the retry delay with exponential backoff.
 * @param {number} attemptIndex - The current attempt index (0-based).
 * @returns {number} - Delay in milliseconds.
 */
export const getRetryDelay = (attemptIndex) => {
    return Math.min(1000 * 2 ** attemptIndex, 30000);
};

/**
 * Default query options with retry logic for network errors.
 */
export const defaultQueryOptions = {
    retry: shouldRetryQuery,
    retryDelay: getRetryDelay,
};

/**
 * SYNC retry for milestone queries. Contract-stable MILESTONE_* errors are
 * never retried; only transient network failures are (≤3 attempts). This
 * deliberately does not reuse the shared shouldRetryQuery: react-query's
 * retryer calls `retry(failureCount, error)` without awaiting — a returned
 * Promise is truthy → the query retries forever and isError never settles
 * (the denied/gated UI and the provider's missing-RPC gate depend on it).
 */
export const retryMilestoneQuery = (failureCount, error) =>
    failureCount < 3 && isSupabaseNetworkError(error);

export const Query = {
    announcements: {
        settings: (orgID) => useQuery({ queryKey: QueryKeys.announcements.settings(orgID), queryFn: getAnnouncementSettings, enabled: !!orgID, staleTime: 0, retry: shouldRetryQuery }),
        all: (orgID, enabled = true) => useQuery({ queryKey: QueryKeys.announcements.all(orgID), queryFn: getAnnouncements, enabled: !!orgID && enabled, staleTime: 0, retry: shouldRetryQuery, refetchInterval: 15000 }),
        report: (orgID, id, enabled = true) => useQuery({ queryKey: QueryKeys.announcements.report(orgID, id), queryFn: () => getAnnouncementReport(id), enabled: !!orgID && !!id && enabled, staleTime: 0, retry: shouldRetryQuery, refetchInterval: query => ['queued', 'sending'].includes(query.state.data?.status) ? 5000 : false }),
    },
    guides: {
        state: (accountID) => useQuery({
            queryKey: QueryKeys.guides.state(accountID),
            queryFn: () => getGuideState(accountID),
            enabled: !!accountID,
            retry: false,
            staleTime: 0,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
        }),
    },
    assistant: {
        sessions: ({ organizationID, personID, options } = {}) => useQuery({
            queryKey: QueryKeys.assistant.sessions(organizationID, personID),
            queryFn: () => getAssistantSessions({ organizationID }),
            staleTime: 1000 * 30,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        messages: ({ organizationID, personID, sessionID, options } = {}) => useQuery({
            queryKey: QueryKeys.assistant.messages(organizationID, personID, sessionID),
            queryFn: () => getAssistantMessages({ organizationID, sessionID }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID && !!sessionID,
            ...options,
        }),
    },
    maintenance: {
        status: () => useQuery({
            queryKey: QueryKeys.maintenance.status(),
            queryFn: () => getMaintenanceStatus(),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
        })
    },
    importAssociations: {
        all: () => useQuery({
            queryKey: QueryKeys.importAssociations.all(),
            queryFn: () => getImportAssociations(),
            staleTime: Infinity,
            refetchOnMount: 'always',
            ...defaultQueryOptions
        })
    },
    importTemplates: {
        all: () => useQuery({
            queryKey: QueryKeys.importTemplates.all(),
            queryFn: () => getImportTemplates(),
            staleTime: Infinity,
            ...defaultQueryOptions
        })
    },
    kpis: {
        attendanceUnique: ({startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.kpis.attendanceUnique({startDate, endDate}),
            queryFn: () => getAttendanceUniqueKPIs(startDate, endDate),
            staleTime: Infinity, 
            ...defaultQueryOptions,
            enabled: !!startDate && !!endDate,
            ...options
        }),
        attendanceFirstFouthTimeVisitors: ({startDate, endDate}) => useQuery({
            queryKey: QueryKeys.kpis.attendanceFirstFouthTimeVisitors({startDate, endDate}),
            queryFn: () => getAttendanceFirstFouthTimeVisitorsKPIs(startDate, endDate),
            staleTime: Infinity, ...defaultQueryOptions
        }),
        attendanceDateFields: ({startDate, endDate, dateFieldID}) => useQuery({
            queryKey: QueryKeys.kpis.attendanceDateFields({startDate, endDate, dateFieldID}),
            queryFn: () => getAttendanceDateFieldsKPIs(startDate, endDate, dateFieldID),
            staleTime: Infinity, ...defaultQueryOptions
        }),
        attendanceUniqueDetail: ({startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.kpis.attendanceUniqueDetail({startDate, endDate}),
            queryFn: () => getAttendanceUniqueDetail(startDate, endDate),
            staleTime: Infinity, ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        attendanceFirstFouthTimeVisitorsDetail: ({startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.kpis.attendanceFirstFouthTimeVisitorsDetail({startDate, endDate}),
            queryFn: () => getAttendanceFirstFouthTimeVisitorsDetail(startDate, endDate),
            staleTime: Infinity, ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        attendanceWeeklyUniqueAvg: ({startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.kpis.attendanceWeeklyUniqueAvg({startDate, endDate}),
            queryFn: () => getAttendanceWeeklyUniqueAvgKPIs(startDate, endDate),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!startDate && !!endDate,
            ...options
        }),
    },
    reports: {
        missed: ({days, eventID, filters, searchText}) => useQuery({
            queryKey: QueryKeys.reports.missed(days, eventID, filters, searchText),
            queryFn: () => getMissedReport({days, eventID, filters, searchText}),
            staleTime: Infinity, ...defaultQueryOptions
        }),
        birthdays: ({days, filters, searchText}) => useQuery({
            queryKey: QueryKeys.reports.birthdays(days, filters, searchText),
            queryFn: () => getBirthdayReport({days, filters, searchText}),
            staleTime: Infinity, ...defaultQueryOptions
        }),
        volunteerUtilization: ({startDate, endDate, dueTypes, options} = {}) => useQuery({
            queryKey: QueryKeys.reports.volunteerUtilization({startDate, endDate, dueTypes}),
            queryFn: () => getVolunteerUtilization({startDate, endDate, dueTypes}),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!startDate && !!endDate,
            ...options
        })
    },
    organization: {
        byId: ({id = null, options} = {}) => useQuery({
            queryKey: QueryKeys.organization.byId(id), 
            queryFn:() => getOrganization(id), 
            staleTime: 1000 * 60 * 15, 
            ...defaultQueryOptions, 
            ...options
        }),
        byUserID: ({userID, options}) => useQuery({
            queryKey: QueryKeys.organization.byUserID({userID}), 
            queryFn: () => getUsersOrganizations(userID),
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    organizationEntitlements: {
        current: ({options} = {}) => useQuery({
            queryKey: QueryKeys.organizationEntitlements.current(getCachedOrgID()),
            queryFn: () => getOrganizationEntitlements(),
            // Plan transitions bump planRevision server-side — recheck on
            // focus/reconnect so a stale session can't keep paid access.
            staleTime: 1000 * 60,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
            ...defaultQueryOptions,
            ...options
        }),
    },
    registrations: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.registrations.all(), 
            queryFn: () => getRegistrations(), 
            staleTime: 1000 * 60 * 5, 
            ...defaultQueryOptions, 
            ...options 
        }),
        byRequestingUser: ({requestingUserID, options} = {}) => useQuery({
            queryKey: QueryKeys.registrations.byRequestingUser(requestingUserID), 
            queryFn: () => getRegistrationsByRequestingUser(requestingUserID), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    registeredUsers: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.registeredUsers.all(), 
            queryFn: () => getRegisteredUsers(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    invites: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.invites.all(), 
            queryFn: () => getInvites(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        forUser: ({email, options} = {}) => useQuery({
            queryKey: QueryKeys.invites.forUser(email), 
            queryFn: () => getInvitesForUser(email), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    people: {
        all: ({searchTerm, filters, filterLogic, sortKey, sortDirection, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.people.all({searchTerm, filters, filterLogic, sortKey, sortDirection}),
            queryFn: ({pageParam, signal}) => getPeople({pageParam, searchTerm, filters, filterLogic, sortKey, sortDirection, signal}),
            staleTime: Infinity,
            placeholderData: keepPreviousData,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage,
            ...options
        }),
        recentAttendance: ({eventID, searchTerm, eventInstanceID, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.people.recentAttendance(eventID, searchTerm, eventInstanceID), 
            queryFn: ({pageParam, signal}) => getRecentAttendance({pageParam, eventID, searchTerm, eventInstanceID, signal}),
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage, 
            ...options
        }),
        byId: ({id, options}) => {
            // Plan-aware keying: Free profiles come from get_free_person_profile
            // and must never read a cached paid profile (which carries composed
            // customFieldValues). getPersonProfile stays the single entry point —
            // it resolves the plan internally and routes accordingly.
            const { data: entitlements } = Query.organizationEntitlements.current();
            const plan = isFreeOrg(entitlements) ? 'free' : 'full';
            return useQuery({
                queryKey: QueryKeys.people.byId(id, plan),
                queryFn: () => getPersonProfile(id),
                staleTime: Infinity,
                ...defaultQueryOptions,
                ...options
            });
        },
        basicById: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.people.basicById(id),
            queryFn: () => getPersonBasic(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
        byName: ({firstName, lastName, options} = {}) => useQuery({
            queryKey: QueryKeys.people.byName(firstName, lastName),
            queryFn: () => findPeopleByName(firstName, lastName),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            ...options
        }),
        byIdForMerge: ({id, options}) => {
            const { data: entitlements } = Query.organizationEntitlements.current();
            const plan = isFreeOrg(entitlements) ? 'free' : 'full';
            return useQuery({
                queryKey: QueryKeys.people.byIdForMerge(id, plan),
                queryFn: () => getPersonForMerge(id),
                staleTime: Infinity, ...defaultQueryOptions,
                ...options
            });
        },
        potentialDuplicates: (options = {}) => useQuery({
            queryKey: QueryKeys.people.potentialDuplicates(),
            queryFn: () => getPotentialDuplicates(),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            ...options
        }),
        loggedInUser: ({options = {}} = {}) => {
            const {select: callerSelect, ...rest} = options;
            return useQuery({
                queryKey: QueryKeys.people.loggedInUser(),
                queryFn: () => getLoggedInUserInfo(),
                staleTime: 1000 * 60 * 15,
                select: (data) => {
                    if (data && typeof data.can !== 'function') {
                        assignPermissions(data);
                    }
                    // getLoggedInUserInfo returns `false` in bail-out paths (no org,
                    // no session, transient errors). Optional chaining `?.` does NOT
                    // guard `false`, so `false?.can(...)` throws "undefined is not a
                    // function". Coerce to `null` so `null?.can(...)` short-circuits
                    // safely across all consumers. See CHURCH-APP-19M.
                    const normalized = data || null;
                    // callerSelect composes AFTER normalization so callers can
                    // subscribe to a narrow slice (e.g. just organizationID)
                    // without re-running assignPermissions or losing the
                    // false→null coercion.
                    return callerSelect ? callerSelect(normalized) : normalized;
                },
                ...defaultQueryOptions,
                ...rest
            });
        },
        attendanceHistory: ({personID, eventName = null, startDate, endDate, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.people.attendanceHistory(personID, eventName, startDate, endDate), 
            queryFn: ({pageParam}) => getPersonAttendanceHistory({pageParam, personID, eventName, startDate, endDate}),
            staleTime: Infinity, 
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage, 
            ...defaultQueryOptions,
            ...options
        }),
        withConversationAccess: ({orgID, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.people.withConversationAccess(orgID),
            queryFn: async () => {
                const people = await getPeopleWithConversationAccess(orgID);
                return { nextPage: undefined, data: people };
            },
            staleTime: 1000 * 60 * 5, // 5 min — refresh on remount/focus
            ...defaultQueryOptions,
            getNextPageParam: () => undefined,
            ...options
        }),
        
    },
    devices: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.devices.all(),
            queryFn: () => getDevices(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
    },
    apiKeys: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.apiKeys.all(),
            queryFn: () => getApiKeys(),
            staleTime: 1000 * 60,
            ...defaultQueryOptions,
            ...options
        }),
    },
    quickFilters: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.quickFilters.all(), 
            queryFn: () => getQuickFilters(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    profileViews: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.profileViews.all(),
            queryFn: () => getProfileViews(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.profileViews.byId(id),
            queryFn: () => getProfileView(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
        // RPC-resolved card payload — short staleTime since underlying person
        // data changes frequently. `config` renders an unsaved draft (the
        // saved-view lookup is skipped), so enabled needs a person plus
        // either a saved view or a draft config.
        card: ({viewID, personID, config, options} = {}) => useQuery({
            queryKey: QueryKeys.profileViews.card(viewID, personID, config),
            queryFn: () => getProfileViewCard({ viewID, personID, config }),
            staleTime: 1000 * 30,
            ...defaultQueryOptions,
            enabled: !!personID && (!!viewID || !!config),
            ...options
        }),
    },
    personCustomFieldSections:{
        all: ({options} = {}) => {
            // Custom fields are a paid-only module — never fetch for a
            // positively identified Free org, even if a caller forgot to gate.
            const { data: entitlements } = Query.organizationEntitlements.current();
            return useQuery({
            queryKey: QueryKeys.personCustomFieldSections.all(),
            queryFn: () => getPersonCustomFieldSections(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !isFreeOrg(entitlements),
            ...options
            });
        },
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.personCustomFieldSections.byId(id), 
            queryFn: () => getPersonCustomFieldSection(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    eventCustomFieldSections:{
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.eventCustomFieldSections.all(), 
            queryFn: () => getEventCustomFieldSections(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.eventCustomFieldSections.byId(id), 
            queryFn: () => getEventCustomFieldSection(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    personCustomFields:{
        all: ({options} = {}) => {
            const { data: entitlements } = Query.organizationEntitlements.current();
            return useQuery({
            queryKey: QueryKeys.personCustomFields.all(),
            queryFn: () => getPersonCustomFields(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !isFreeOrg(entitlements),
            ...options
            });
        },
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.personCustomFields.byId(id), 
            queryFn: () => getPersonCustomField(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    protectedPersonFields: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.protectedPersonFields.all(), 
            queryFn: () => getProtectedPersonFields(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    eventCustomFields:{
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.eventCustomFields.all(), 
            queryFn: () => getEventCustomFields(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    customFieldSections: {
        all: ({module, options} = {}) => {
            const { data: entitlements } = Query.organizationEntitlements.current();
            return useQuery({
            queryKey: QueryKeys.customFieldSections.all(module),
            queryFn: () => getCustomFieldSections(module),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !isFreeOrg(entitlements),
            ...options
            });
        },
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.customFieldSections.byId(id), 
            queryFn: () => getCustomFieldSection(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    customFields: {
        all: ({module, options} = {}) => {
            const { data: entitlements } = Query.organizationEntitlements.current();
            return useQuery({
            queryKey: QueryKeys.customFields.all(module),
            queryFn: () => getCustomFields(module),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !isFreeOrg(entitlements),
            ...options
            });
        },
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.customFields.byId(id), 
            queryFn: () => getCustomField(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    events: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.events.all(), 
            queryFn: () => getEvents(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        picker: ({recentOnly = true, options} = {}) => useQuery({
            queryKey: QueryKeys.events.picker(recentOnly),
            queryFn: () => getEvents({recentOnly}),
            staleTime: 5 * 60 * 1000,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.events.byId(id), 
            queryFn: () => getEvent(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        analytics: ({eventID, numberOfDays, options} = {}) => useQuery({
            queryKey: QueryKeys.events.analytics(eventID, numberOfDays), 
            queryFn: () => getEventAnalytics(eventID, numberOfDays), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        uniqueAttendees: ({eventID, numberOfDays, options} = {}) => useQuery({
            queryKey: QueryKeys.events.uniqueAttendees(eventID, numberOfDays),
            queryFn: () => getEventUniqueAttendees(eventID, numberOfDays),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        uniqueAttendeesDetail: ({eventID, numberOfDays, options} = {}) => useQuery({
            queryKey: QueryKeys.events.uniqueAttendeesDetail(eventID, numberOfDays),
            queryFn: () => getEventUniqueAttendeesDetail(eventID, numberOfDays),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        publicJesusTentRevivalStats: ({options} = {}) => useQuery({
            queryKey: QueryKeys.events.publicJesusTentRevivalStats(),
            queryFn: () => getPublicJesusTentRevivalStats(),
            staleTime: 25000,
            ...defaultQueryOptions,
            retry: 1,
            ...options
        }),
        byIdForMerge: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.events.byIdForMerge(id),
            queryFn: () => getEventForMerge(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
    },
    blackoutDates: {
        all: ({filter = 'active', options} = {}) => useQuery({
            queryKey: QueryKeys.blackoutDates.all(), 
            queryFn: () => getBlackoutDates({filter}), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byMonth: ({month, year, personID = null, options} = {}) => useQuery({
            queryKey: QueryKeys.blackoutDates.byMonth(month, year, personID), 
            queryFn: () => getBlackoutDatesForMonth({month, year, personID}), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    eventInstances: {
        forDate: ({date, dateKey, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.forDate(dateKey),
            queryFn: () => getEventInstancesForDate(date),
            staleTime: 1000*60*5,
            ...defaultQueryOptions,
            enabled: !!date,
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.byId(id), 
            queryFn: () => getEventInstance(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        attendance: ({eventInstanceID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.attendance(eventInstanceID), 
            queryFn: () => getAttendance(eventInstanceID), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        registrants: ({eventInstanceID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.registrants(eventInstanceID),
            queryFn: () => getEventRegistrants(eventInstanceID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        registrantCodes: ({eventInstanceID, personID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.registrantCodes(eventInstanceID, personID),
            queryFn: () => getEventRegistrantCodes({ eventInstanceID, personID }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        registrantPaths: ({eventInstanceID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.registrantPaths(eventInstanceID),
            queryFn: () => getEventRegistrantPaths({ eventInstanceID }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        registrantPathEnrollments: ({eventInstanceID, personID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.registrantPathEnrollments(eventInstanceID, personID),
            queryFn: () => getRegistrantPathEnrollments({ eventInstanceID, personID }),
            staleTime: Infinity,
            refetchOnMount: 'always',
            ...defaultQueryOptions,
            ...options
        }),
        registrantDetail: ({eventInstanceID, personID, attendanceEventInstanceID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.registrantDetail(eventInstanceID, personID, attendanceEventInstanceID),
            queryFn: () => getRegistrantDetail({ eventInstanceID, personID, attendanceEventInstanceID }),
            ...defaultQueryOptions,
            enabled: !!eventInstanceID && !!personID,
            ...options
        }),
        pendingRegistrants: ({eventInstanceID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.pendingRegistrants(eventInstanceID),
            queryFn: () => getPendingEventRegistrants(eventInstanceID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byEventId: ({eventID, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.eventInstances.byEventId(eventID),
            queryFn: ({pageParam = 0}) => getPastEventInstances({eventID, pageParam}),
            getNextPageParam: (lastPage) => lastPage?.nextPage,
            initialPageParam: 0,
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byEventIdAll: ({eventID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.byEventIdAll(eventID),
            queryFn: () => getEventInstancesByEventID(eventID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!eventID,
            ...options
        }),
        upcomingVolunteerTasks: ({eventID, options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.upcomingVolunteerTasks(eventID),
            queryFn: () => getUpcomingEventInstancesWithTasks(eventID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!eventID,
            ...options
        }),
        forRegistration: ({options} = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.forRegistration(),
            queryFn: () => getEventInstancesForRegistration(),
            staleTime: 1000*60*5,
            ...defaultQueryOptions,
            ...options
        }),
        registrationExtensions: ({ eventInstanceID, options } = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.registrationExtensions(eventInstanceID),
            queryFn: () => getEventRegistrationExtensions({ eventInstanceID }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options,
        }),
        registrationExtensionSource: ({ eventInstanceID, options } = {}) => useQuery({
            queryKey: QueryKeys.eventInstances.registrationExtensionSource(eventInstanceID),
            queryFn: () => getEventRegistrationExtensionSource({ eventInstanceID }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options,
        }),
    },
    addresses: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.addresses.all(), 
            queryFn: () => getAddresses(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.addresses.byId(id), 
            queryFn: () => getAddress({id}), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    locations: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.locations.all(), 
            queryFn: () => getLocations(),
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.locations.byId(id), 
            queryFn: () => getLocation(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    calendars: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.calendars.all(), 
            queryFn: () => getCalendars(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.calendars.byId(id), 
            queryFn: () => getCalendar(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    conversations: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.conversations.all(), 
            queryFn: () => getConversations(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byUserId: ({userId, options}) => useQuery({
            queryKey: QueryKeys.conversations.byUserId(userId), 
            queryFn: () => getConversations(userId), 
            staleTime: 1000*60*5, //Realtime-updated while mounted, but refetch on focus/remount after 5 min
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.conversations.byId(id), 
            queryFn: () => getConversation(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        orgAll: ({options} = {}) => useQuery({
            queryKey: QueryKeys.conversations.orgAll(),
            queryFn: () => getAllOrgConversations(),
            staleTime: 1000*60*5,
            ...defaultQueryOptions,
            ...options
        }),
    },
    boards: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.boards.all(),
            queryFn: () => getBoards(),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.boards.byId(id), 
            queryFn: () => getBoard(id), 
            staleTime: 1000*60*5, 
            ...defaultQueryOptions, 
            ...options
        }),
        orgAll: ({options} = {}) => useQuery({
            queryKey: QueryKeys.boards.orgAll(),
            queryFn: () => getAllOrgBoards(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        members: ({boardID, options} = {}) => useQuery({
            queryKey: QueryKeys.boards.members(boardID),
            queryFn: () => getBoardMembers(boardID),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            ...options
        }),
    },
    posts: {
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.posts.byId(id), 
            queryFn: () => getPost(id), 
            staleTime: 1000*60*5, 
            ...defaultQueryOptions, 
            ...options
        }),
        byBoardId: ({boardID, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.posts.byBoardId(boardID),
            queryFn: ({pageParam}) => getPostsForBoard(boardID, pageParam),
            initialPageParam: 0,
            staleTime: 1000*60*5,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage ?? null,
            ...options
        }),
        myBoardsFeed: ({boardIDs, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.posts.myBoardsFeed(),
            queryFn: ({pageParam}) => getMyBoardsFeed(boardIDs, pageParam),
            initialPageParam: 0,
            enabled: !!boardIDs && boardIDs.length > 0,
            staleTime: 1000*60*5,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage ?? null,
            ...options
        }),
        viewers: ({postID, options} = {}) => useQuery({
            queryKey: QueryKeys.posts.viewers(postID),
            queryFn: () => getPostViewers(postID),
            staleTime: 1000*60,
            ...defaultQueryOptions,
            ...options
        }),
    },
    comments: {
        byPostId: ({postID, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.comments.byPostId(postID), 
            queryFn: ({pageParam}) => getCommentsForPost(postID, pageParam), 
            initialPageParam: 0,
            staleTime: 1000*60, 
            ...defaultQueryOptions, 
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage ?? null,
            ...options
        }),
    },
    messages: {
        byConversationId: ({conversationID, options}) => useInfiniteQuery({
            queryKey: QueryKeys.messages.byConversationId(conversationID), 
            queryFn: ({pageParam}) => getMessagesForConversation(conversationID, pageParam), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage || null,
            getPreviousPageParam: (lastPage, _pages) => lastPage.previousPage || null,
            ...options
        }),
    },
    tasks: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.tasks.all(), 
            queryFn: () => getTasks(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        infinite: ({options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.tasks.infinite(), 
            queryFn: ({pageParam}) => getTasks({pageParam}), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            getNextPageParam: (lastPage, _pages) => lastPage.nextToken, 
            ...options
        }),
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.tasks.byId(id), 
            queryFn: () => getTask(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byDueType: ({dueType, options}) => tasksByDueType(dueType, options),
        upcomingTasks: ({personID, horizonDays = 7, options}) => useQuery({
            queryKey: QueryKeys.tasks.upcomingTasks(personID, horizonDays),
            queryFn: () => upcomingTaskInstancesForPerson(personID, horizonDays),
            staleTime: 1000*60*5, 
            ...defaultQueryOptions, 
            ...options
        }),
        upcomingTaskAssignments: ({personID, horizonDays = 30, options}) => useQuery({
            queryKey: QueryKeys.tasks.upcomingTaskAssignments(personID, horizonDays),
            queryFn: () => upcomingTaskInstancesAsAssigner(personID, horizonDays),
            staleTime: 1000*60*5,
            ...defaultQueryOptions,
            ...options
        }),
        upcomingTeamTaskInstances: ({teamID, horizonDays = 30, options}) => useQuery({
            queryKey: QueryKeys.tasks.upcomingTeamTaskInstances(teamID, horizonDays),
            queryFn: () => upcomingTaskInstancesForTeam(teamID, horizonDays),
            staleTime: 1000*60*5,
            ...defaultQueryOptions,
            ...options
        }),
        personHistory: ({personID, options} = {}) => useQuery({
            queryKey: QueryKeys.tasks.personHistory(personID),
            queryFn: () => getPersonTaskHistory(personID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        recentAssignees: ({taskID, options}) => useQuery({
            queryKey: QueryKeys.tasks.recentAssignees(taskID),
            queryFn: () => getRecentAssigneesForTask(taskID),
            staleTime: 1000*60*10,
            ...defaultQueryOptions,
            ...options
        }),
        recentAssigneesBatch: ({taskIDs, options}) => useQuery({
            queryKey: QueryKeys.tasks.recentAssigneesBatch(taskIDs),
            queryFn: () => getRecentAssigneesForTasks(taskIDs),
            staleTime: 1000*60*10,
            ...defaultQueryOptions,
            ...options
        })
    },
    taskInstances: {
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.taskInstances.byId(id),
            queryFn: () => getTaskInstance(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        individual: ({options} = {}) => useQuery({
            queryKey: QueryKeys.taskInstances.individual(),
            queryFn: () => getIndividualTaskInstances(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
    },
    taskAutoSchedule: {
        /**
         * Run status / ready-preview poll for the AutoScheduleModal.
         * - Enabled only while a modal-provided run is active (caller passes
         *   options.enabled tied to its generating phase), so closing the
         *   sheet, switching org, or signing out stops polling: the key is
         *   org+person scoped and the hook disables on identity change.
         * - Polls at the server-returned `pollAfterMs` while the run is
         *   queued/generating; terminal statuses stop the interval.
         * - gcTime 0: draft payload is dropped the moment the query is
         *   unused — it is also excluded from AsyncStorage persistence via
         *   the PERSISTABLE_KEYS allowlist.
         * - Transient network failures retry with bounded backoff; contract
         *   errors (run_not_found, preview_expired, ...) never retry.
         */
        preview: ({orgID, personID, runID, options} = {}) => useQuery({
            queryKey: QueryKeys.taskAutoSchedule.preview(orgID, personID, runID),
            queryFn: () => getAutoScheduleStatus({ runID }),
            enabled: !!orgID && !!personID && !!runID,
            staleTime: 0,
            gcTime: 0,
            retry: (failureCount, error) => failureCount < 3 && isSupabaseNetworkError(error),
            retryDelay: getRetryDelay,
            refetchInterval: (query) => {
                const data = query.state.data;
                // No data yet (or a transient error before the first response)
                // still polls at the default cadence — the modal tolerates
                // transient status errors and needs the interval to survive
                // them; `enabled` (generating phase) is the real off-switch.
                if (data && !AUTO_SCHEDULE_ACTIVE_STATUSES.includes(data?.status)) return false;
                const ms = Number(data?.pollAfterMs);
                // Clamp server guidance to a sane client bound.
                return Number.isFinite(ms) && ms > 0 ? Math.min(Math.max(ms, 500), 30000) : 1500;
            },
            refetchIntervalInBackground: false,
            ...options
        }),
        /**
         * "Do not suggest" rules (AutoScheduleExclusions) covering the current
         * preview's tasks — drives the add/remove toggle on suggestion rows.
         * Scoped by run like the preview query; gcTime 0 keeps it ephemeral.
         */
        exclusions: ({ orgID, personID, runID, taskIDs, options } = {}) => useQuery({
            queryKey: QueryKeys.taskAutoSchedule.exclusions(orgID, personID, runID),
            queryFn: () => fetchAutoScheduleExclusions({ taskIDs }),
            enabled: !!orgID && !!personID && !!runID && (taskIDs?.length ?? 0) > 0,
            staleTime: 60000,
            gcTime: 0,
            ...options
        }),
    },
    taskTeams: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.taskTeams.all(),
            queryFn: () => getVolunteerTeams(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.taskTeams.byId(id),
            queryFn: () => getVolunteerTeam(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        })
    },
    taskAssignmentTemplates: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.taskAssignmentTemplates.all(),
            queryFn: () => getTaskAssignmentTemplates(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.taskAssignmentTemplates.byId(id),
            queryFn: () => getTaskAssignmentTemplate(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        })
    },
    roles: {
        all: ({user, options} = {}) => useQuery({
            queryKey: QueryKeys.roles.all(), 
            queryFn: () => getRoles(user), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options}) => useQuery({
            queryKey: QueryKeys.roles.byId(id), 
            queryFn: () => getRole(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    roleFolders: {
        all: ({user, options} = {}) => useQuery({
            queryKey: QueryKeys.roleFolders.all(), 
            queryFn: () => getRolesInFolders(user), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.roleFolders.byId(id), 
            queryFn: () => getRoleFolder(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    permissions: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.permissions.all(), 
            queryFn: () => getPermissions(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.permissions.byId(id), 
            queryFn: () => getPermission(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        infinite: ({options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.permissions.infinite(), 
            queryFn: ({pageParam}) => getPermissions({pageParam: pageParam}), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            getNextPageParam: (lastPage, _pages) => lastPage.nextToken, 
            ...options
        }),
    },
    songs: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.songs.all(), 
            queryFn: () => getSongs(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.songs.byId(id), 
            queryFn: () => getSong(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    smallGroupSessions: {
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroupSessions.byId(id), 
            queryFn: () => getSmallGroupSession(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    smallGroups: {
        all: ({searchTerm, filters, sortKey, sortDirection, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.smallGroups.all({searchTerm, filters, sortKey, sortDirection}), 
            queryFn: ({pageParam}) => getSmallGroups({pageParam, searchTerm, filters, sortKey, sortDirection}), 
            staleTime: Infinity, 
            ...defaultQueryOptions,
            getNextPageParam: (lastPage, _pages) => lastPage.nextPage,  
            ...options
        }),
        forDropdown: ({smallGroupTypeID = null, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.forDropdown(smallGroupTypeID),
            queryFn: () => getSmallGroupsForDropdown(smallGroupTypeID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.byId(id), 
            queryFn: () => getSmallGroup(id), 
            staleTime: Infinity,
            refetchOnMount: 'always',
            ...defaultQueryOptions, 
            ...options
        }),
        byIdForMerge: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.byIdForMerge(id),
            queryFn: () => getSmallGroupForMerge(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        metrics: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.metrics({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getSmallGroupMetrics({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!startDate && !!endDate,
            ...options
        }),
        trends: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.trends({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getSmallGroupTrends({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!startDate && !!endDate,
            ...options
        }),
        reportingStats: ({smallGroupTypeID, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.reportingStats(smallGroupTypeID),
            queryFn: () => getSmallGroupReportingStats(smallGroupTypeID),
            staleTime: Infinity, 
            ...defaultQueryOptions,
            enabled: !!smallGroupTypeID,
            ...options
        }),
        dateStats: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.dateStats({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getSmallGroupDateStats({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity, 
            ...defaultQueryOptions,
            enabled: !!smallGroupTypeID && !!startDate && !!endDate,
            ...options
        }),
        teachersDetail: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.teachersDetail({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getSmallGroupTeachersDetail({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        studentsDetail: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.studentsDetail({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getSmallGroupStudentsDetail({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        activeGroupsDetail: ({smallGroupTypeID, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.activeGroupsDetail({smallGroupTypeID}),
            queryFn: () => getActiveGroupsDetail({smallGroupTypeID}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        activeLeadersDetail: ({smallGroupTypeID, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.activeLeadersDetail({smallGroupTypeID}),
            queryFn: () => getActiveLeadersDetail({smallGroupTypeID}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        activeStudentsDetail: ({smallGroupTypeID, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.activeStudentsDetail({smallGroupTypeID}),
            queryFn: () => getActiveStudentsDetail({smallGroupTypeID}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        sessionsDetail: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.sessionsDetail({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getSessionsDetail({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        newGroupsDetail: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.newGroupsDetail({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getNewGroupsDetail({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        completedGroupsDetail: ({smallGroupTypeID, startDate, endDate, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.completedGroupsDetail({smallGroupTypeID, startDate, endDate}),
            queryFn: () => getCompletedGroupsDetail({smallGroupTypeID, startDate, endDate}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: false,
            ...options
        }),
        leaderReport: ({smallGroupTypeID, startDate, endDate, includeWithoutMeetings = false, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroups.leaderReport({smallGroupTypeID, startDate, endDate, includeWithoutMeetings}),
            queryFn: () => getSmallGroupLeaderReport({smallGroupTypeID, startDate, endDate, includeWithoutMeetings}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!smallGroupTypeID && !!startDate && !!endDate,
            ...options
        }),
        sessionsPaginated: ({smallGroupTypeID, startDate, endDate, smallGroupID, teacherID, searchTerm, sortKey, sortDirection, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.smallGroups.sessionsPaginated({smallGroupTypeID, startDate, endDate, smallGroupID, teacherID, searchTerm, sortKey, sortDirection}),
            queryFn: ({pageParam}) => getSmallGroupSessionsPaginated({smallGroupTypeID, startDate, endDate, smallGroupID, teacherID, searchTerm, sortKey, sortDirection, pageParam}),
            staleTime: Infinity, 
            ...defaultQueryOptions,
            getNextPageParam: (lastPage) => lastPage.nextPage,
            ...options
        }),
    },
    bibleStudies: {
        // 'own' = caller's primary/co-teacher studies; 'all' needs Manage Bible
        // Studies (backend enforces — callerCanManage on rows mirrors it).
        all: ({scope = 'own', status, searchTerm, teacherID, sortKey, sortDirection, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.bibleStudies.all({scope, status, searchTerm, teacherID, sortKey, sortDirection}),
            queryFn: ({pageParam}) => getBibleStudies({scope, status, searchTerm, teacherID, sortKey, sortDirection, pageParam}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage) => lastPage.nextPage,
            ...options
        }),
        // Study picker source — purpose-scoped forDropdown so Bible Study types
        // never leak into ordinary Small Groups pickers (and vice versa).
        forDropdown: ({smallGroupTypeID = null, options} = {}) => useQuery({
            queryKey: QueryKeys.bibleStudies.forDropdown(smallGroupTypeID),
            queryFn: () => getSmallGroupsForDropdown(smallGroupTypeID, 'BIBLE_STUDY'),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        sessions: ({scope = 'own', smallGroupID, startDate, endDate, teacherID, searchTerm, sortKey, sortDirection, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.bibleStudies.sessions({scope, smallGroupID, startDate, endDate, teacherID, searchTerm, sortKey, sortDirection}),
            queryFn: ({pageParam}) => getBibleStudySessions({scope, smallGroupID, startDate, endDate, teacherID, searchTerm, sortKey, sortDirection, pageParam}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage) => lastPage.nextPage,
            ...options
        }),
        students: ({smallGroupID, options} = {}) => useQuery({
            queryKey: QueryKeys.bibleStudies.students(smallGroupID),
            queryFn: () => getBibleStudyStudents(smallGroupID),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!smallGroupID,
            ...options
        }),
        sessionNotes: ({smallGroupID, options} = {}) => useQuery({
            queryKey: QueryKeys.bibleStudies.sessionNotes(smallGroupID),
            queryFn: () => getBibleStudySessionNotes(smallGroupID),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!smallGroupID,
            ...options
        }),
        peopleNotes: ({smallGroupID, options} = {}) => useQuery({
            queryKey: QueryKeys.bibleStudies.peopleNotes(smallGroupID),
            queryFn: () => getBibleStudyPeopleNotes(smallGroupID),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!smallGroupID,
            ...options
        }),
        // Teacher report payload (bible_study_report_teacher_detail). 'all'
        // needs View Bible Study Reports / Manage — backend enforces. Null
        // dates resolve to the trailing 90 org-local days in the data layer.
        teacherDetail: ({scope = 'own', teacherID, startDate = null, endDate = null, options} = {}) => useQuery({
            queryKey: QueryKeys.bibleStudies.teacherDetail({scope, teacherID, startDate, endDate}),
            queryFn: () => bibleStudyTeacherDetail({scope, teacherID, startDate, endDate}),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!teacherID,
            ...options
        }),
        // Student outcome totals (bible_study_report_student_outcomes) —
        // trailing windowDays org-local days when no dates are passed.
        // contributionsPermitted mirrors the server's View Contributions gate.
        studentOutcomes: ({scope = 'own', teacherID, startDate = null, endDate = null, windowDays, options} = {}) => useQuery({
            queryKey: QueryKeys.bibleStudies.studentOutcomes({scope, teacherID, startDate, endDate, windowDays}),
            queryFn: () => bibleStudyStudentOutcomes({scope, teacherID, startDate, endDate, windowDays}),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!teacherID,
            ...options
        }),
    },
    smallGroupTypes: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroupTypes.all(), 
            queryFn: () => getSmallGroupTypes(), 
            staleTime: 1000 * 60 * 5, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.smallGroupTypes.byId(id), 
            queryFn: () => getSmallGroupType(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    links: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.links.all(), 
            queryFn: () => getLinks(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.links.byId(id), 
            queryFn: () => getLink(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    activity: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.activity.all(), 
            queryFn: () => getActivity(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        feed: ({ filters = {}, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.activity.feed(filters),
            queryFn: ({ pageParam = 0 }) => getActivityFeed({ ...filters, offset: pageParam }),
            staleTime: 1000 * 60 * 5, // 5 minutes
            getNextPageParam: (lastPage, allPages) => {
                if (!lastPage.hasMore) return undefined;
                return allPages.reduce((sum, page) => sum + page.activities.length, 0);
            },
            ...defaultQueryOptions,
            ...options
        }),
        byActor: ({ actorID, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.activity.byActor(actorID),
            queryFn: ({ pageParam = 0 }) => getActivityFeed({ actorID, offset: pageParam }),
            staleTime: 1000 * 60 * 5,
            getNextPageParam: (lastPage, allPages) => {
                if (!lastPage.hasMore) return undefined;
                return allPages.reduce((sum, page) => sum + page.activities.length, 0);
            },
            ...defaultQueryOptions,
            ...options
        }),
        bySubject: ({ subjectType, subjectID, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.activity.bySubject(subjectType, subjectID),
            queryFn: ({ pageParam = 0 }) => getActivityFeed({ subjectType, subjectID, offset: pageParam }),
            staleTime: 1000 * 60 * 5,
            getNextPageParam: (lastPage, allPages) => {
                if (!lastPage.hasMore) return undefined;
                return allPages.reduce((sum, page) => sum + page.activities.length, 0);
            },
            ...defaultQueryOptions,
            ...options
        }),
    },
    notificationTypes: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.notificationTypes.all(), 
            queryFn: () => getNotificationTypes(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    global: {
        all: ({search_term, match_all, partial, types, options} = {}) => useQuery({
            queryKey: QueryKeys.global.all(search_term, match_all, partial, types), 
            queryFn: () => globalSearch({search_term, match_all, partial, types}), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    gifs: {
        all: ({searchTerm, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.gifs.all(searchTerm), 
            queryFn: ({pageParam}) => getGifs({searchTerm, pageParam}), 
            staleTime: Infinity, ...defaultQueryOptions,
            getNextPageParam: (lastPage, _pages) => lastPage.next,
            ...options
        })
    },
    printLabels: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.printLabels.all(), 
            queryFn: () => getPrintLabels(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
    },
    contributionBatches: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.contributionBatches.all(), 
            queryFn: () => getBatches(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.contributionBatches.byId(id), 
            queryFn: () => getBatch(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        latest: ({options} = {}) => useQuery({
            queryKey: QueryKeys.contributionBatches.latest(), 
            queryFn: () => getBatch(undefined), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        transactions: ({batchID, searchText, sortConfig, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.contributionBatches.transactions(batchID, searchText, sortConfig),
            queryFn: ({pageParam}) => getBatchTransactions({batchID, pageParam, searchText, sortConfig}),
            initialPageParam: 0,
            getNextPageParam: (lastPage) => lastPage.nextPage,
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        stats: ({batchID, options} = {}) => useQuery({
            queryKey: QueryKeys.contributionBatches.stats(batchID),
            queryFn: () => getBatchStats(batchID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
    },
    contributionFunds: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.contributionFunds.all(), 
            queryFn: () => getFunds(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.contributionFunds.byId(id), 
            queryFn: () => getFund(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    contributionMethods: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.contributionMethods.all(), 
            queryFn: () => getMethods(), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.contributionMethods.byId(id), 
            queryFn: () => getMethod(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        })
    },
    contributionTransactions: {
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.contributionTransactions.byId(id), 
            queryFn: () => getTransaction(id), 
            staleTime: Infinity, 
            ...defaultQueryOptions, 
            ...options
        }),
        byPersonId: ({ personID, personIDs, startDate, endDate, fundID, methodID, search, options } = {}) => useQuery({
            queryKey: QueryKeys.contributionTransactions.byPersonId({ personID, personIDs, startDate, endDate, fundID, methodID, search }),
            queryFn: () => getTransactionsByPerson({ personID, personIDs, startDate, endDate, fundID, methodID, search }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        })
    },
    contributionAnalytics: {
        transactions: ({ startDate, endDate, batchID, giverID, methodIds, amount, options } = {}) => useQuery({
            queryKey: QueryKeys.contributionAnalytics.transactions({ startDate, endDate, batchID, giverID, methodIds, amount }),
            queryFn: () => getContributionsAnalytics({ startDate, endDate, batchID, giverID, methodIds, amount }),
            staleTime: Infinity, ...defaultQueryOptions,
            ...options
        }),
        kpis: ({ startDate, endDate, options } = {}) => useQuery({
            queryKey: QueryKeys.contributionAnalytics.kpis({ startDate, endDate }),
            queryFn: () => getContributionsKPIs({ startDate, endDate }),
            staleTime: Infinity, ...defaultQueryOptions,
            ...options
        }),
        byMonth: ({ startDate, endDate, options } = {}) => useQuery({
            queryKey: QueryKeys.contributionAnalytics.byMonth({ startDate, endDate }),
            queryFn: () => getContributionsByMonth({ startDate, endDate }),
            staleTime: Infinity, ...defaultQueryOptions,
            ...options
        }),
        topGivers: ({ startDate, endDate, limit = 20, options } = {}) => useQuery({
            queryKey: QueryKeys.contributionAnalytics.topGivers({ startDate, endDate, limit }),
            queryFn: () => getTopGivers({ startDate, endDate, limit }),
            staleTime: Infinity, ...defaultQueryOptions,
            ...options
        }),
        byMethod: ({ startDate, endDate, options } = {}) => useQuery({
            queryKey: QueryKeys.contributionAnalytics.byMethod({ startDate, endDate }),
            queryFn: () => getGivingByMethod({ startDate, endDate }),
            staleTime: Infinity, ...defaultQueryOptions,
            ...options
        }),
        byFund: ({ startDate, endDate, options } = {}) => useQuery({
            queryKey: QueryKeys.contributionAnalytics.byFund({ startDate, endDate }),
            queryFn: () => getGivingByFund({ startDate, endDate }),
            staleTime: Infinity, ...defaultQueryOptions,
            ...options
        }),
        availableYears: ({ options } = {}) => useQuery({
            queryKey: QueryKeys.contributionAnalytics.availableYears(),
            queryFn: () => getContributionYears(),
            staleTime: Infinity, ...defaultQueryOptions,
            ...options
        })
    },
    shortcuts: {
        byPersonId: ({ personID, options } = {}) => useQuery({
            queryKey: QueryKeys.shortcuts.byPersonId(personID),
            queryFn: () => getShortcuts(personID),
            staleTime: 1000 * 60 * 5, ...defaultQueryOptions,
            enabled: !!personID,
            ...options
        }),
        recentByPersonId: ({ personID, options } = {}) => useQuery({
            queryKey: QueryKeys.shortcuts.recentByPersonId(personID),
            queryFn: () => getRecentShortcuts(personID),
            staleTime: Infinity, ...defaultQueryOptions,
            enabled: !!personID,
            ...options
        })
    },
    dashboardSections: {
        get: ({ organizationID, accountID, options } = {}) => useQuery({
            queryKey: QueryKeys.dashboardSections.get(organizationID, accountID),
            queryFn: () => getDashboardSections(),
            staleTime: 1000 * 60 * 5, ...defaultQueryOptions,
            ...options
        })
    },
    dashboardData: {
        byPersonId: ({ personID, options } = {}) => useQuery({
            queryKey: QueryKeys.dashboardData.byPersonId(personID),
            queryFn: () => getDashboardData(personID),
            staleTime: 1000 * 60 * 5, ...defaultQueryOptions,
            enabled: !!personID,
            ...options
        })
    },
    quickPersonFields: {
        get: ({options} = {}) => useQuery({
            queryKey: QueryKeys.quickPersonFields.get(),
            queryFn: () => getQuickPersonFields(),
            staleTime: Infinity, 
            ...defaultQueryOptions,
            ...options
        })
    },
    trainingModules: {
        all: ({searchTerm, filters, sortKey, sortDirection, options} = {}) => useInfiniteQuery({
            queryKey: QueryKeys.trainingModules.all({searchTerm, filters, sortKey, sortDirection}),
            queryFn: ({pageParam}) => getTrainingModules({pageParam, searchTerm, filters, sortKey, sortDirection}),
            staleTime: Infinity,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage) => lastPage.nextPage,
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.trainingModules.byId(id),
            queryFn: () => getTrainingModule(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        stats: ({moduleID, options} = {}) => useQuery({
            queryKey: QueryKeys.trainingModules.stats(moduleID),
            queryFn: () => getTrainingModuleStats(moduleID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!moduleID,
            ...options
        }),
    },
    trainingClassInstances: {
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.trainingClassInstances.byId(id),
            queryFn: () => getClassInstance(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
        byTaskInstanceId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.trainingClassInstances.byTaskInstanceId(id),
            queryFn: () => getTrainingClassInstanceByTaskInstanceID(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
    },
    trainingTerms: {
        byModuleId: ({moduleID, options} = {}) => useQuery({
            queryKey: QueryKeys.trainingTerms.byModuleId(moduleID),
            queryFn: () => getTrainingTerms(moduleID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!moduleID,
            ...options
        }),
    },
    trainingOverview: {
        stats: ({options} = {}) => useQuery({
            queryKey: QueryKeys.trainingOverview.stats(),
            queryFn: () => getTrainingOverviewStats(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
    },
    trainingProgress: {
        byPersonId: ({personID, options} = {}) => useQuery({
            queryKey: QueryKeys.trainingProgress.byPersonId(personID),
            queryFn: () => getPersonTrainingProgress(personID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!personID,
            ...options
        }),
    },
    upcomingTrainingClasses: {
        byPersonId: ({personID, options} = {}) => useQuery({
            queryKey: QueryKeys.upcomingTrainingClasses.byPersonId(personID),
            queryFn: () => getUpcomingTrainingClasses(personID),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!personID,
            ...options
        }),
    },
    paths: {
        all: ({options} = {}) => useQuery({
            queryKey: QueryKeys.paths.all(),
            queryFn: () => getPaths(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.paths.byId(id),
            queryFn: () => getPath(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
        forFormTrigger: ({options} = {}) => useQuery({
            queryKey: QueryKeys.paths.forFormTrigger(),
            queryFn: () => getPathsForFormTrigger(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        forEventCheckInTrigger: ({options} = {}) => useQuery({
            queryKey: QueryKeys.paths.forEventCheckInTrigger(),
            queryFn: () => getPathsForEventCheckInTrigger(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        eventsForCheckInPath: ({ pathID, options } = {}) => useQuery({
            queryKey: QueryKeys.paths.eventsForCheckInPath(pathID),
            queryFn: () => getEventsForCheckInPath({ pathID }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!pathID,
            ...options
        }),
        forManualTrigger: ({options} = {}) => useQuery({
            queryKey: QueryKeys.paths.forManualTrigger(),
            queryFn: () => getPathsForManualTrigger(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        enrollmentContext: ({ taskInstanceID, options } = {}) => useQuery({
            queryKey: QueryKeys.paths.enrollmentContext(taskInstanceID),
            queryFn: () => getEnrollmentContextByTaskInstance(taskInstanceID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!taskInstanceID,
            ...options
        }),
        variables: ({ triggerType, formID, options = {} } = {}) => useQuery({
            queryKey: QueryKeys.paths.variables(triggerType, formID),
            queryFn: () => fetchPathVariables({ triggerType, formID }),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!triggerType,
            ...options,
        }),
    },
    automations: {
        // Global AutomationTriggerCatalog rows (families, source params,
        // input specs) — drives the v2 trigger picker.
        triggerCatalog: ({ options } = {}) => useQuery({
            queryKey: QueryKeys.automations.triggerCatalog(),
            queryFn: () => getAutomationTriggerCatalog(),
            staleTime: 1000 * 60 * 15,
            ...defaultQueryOptions,
            ...options,
        }),
        // Source-aware variable registry for one v2 definition
        // (automation_get_variables) — {variables, steps, triggerType,
        // personOptional, schemaVersion, compatibilityMode}.
        variables: ({ pathID, options } = {}) => useQuery({
            queryKey: QueryKeys.automations.variables(pathID),
            queryFn: () => fetchAutomationVariables(pathID),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            enabled: !!pathID,
            ...options,
        }),
    },
    forms: {
        hasEditable: ({ personID, organizationID, options } = {}) => useQuery({
            queryKey: QueryKeys.forms.hasEditable(personID, organizationID),
            queryFn: hasEditableForms,
            ...defaultQueryOptions,
            staleTime: 0,
            enabled: !!personID && !!organizationID,
            ...options,
        }),
        all: ({ options } = {}) => useQuery({
            queryKey: QueryKeys.forms.all(),
            queryFn: () => getForms(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({ id, options } = {}) => useQuery({
            queryKey: QueryKeys.forms.byId(id),
            queryFn: () => getForm(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
        triggeringPath: ({ pathID, options } = {}) => useQuery({
            queryKey: QueryKeys.forms.triggeringPath(pathID),
            queryFn: () => getFormsTriggeringPath({ pathID }),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!pathID,
            ...options
        }),
    },
    formFolders: {
        all: ({ options } = {}) => useQuery({
            queryKey: QueryKeys.formFolders.all(),
            queryFn: () => getFormFolders(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
    },
    formEntries: {
        byFormId: ({ formID, options } = {}) => useQuery({
            queryKey: QueryKeys.formEntries.byFormId(formID),
            queryFn: () => getFormEntries({ formID }),
            staleTime: 0,
            ...defaultQueryOptions,
            enabled: !!formID,
            ...options
        }),
        byId: ({ id, options } = {}) => useQuery({
            queryKey: QueryKeys.formEntries.byId(id),
            queryFn: () => getFormEntry(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
        mine: ({ entryID = null, limit = null, options } = {}) => useQuery({
            queryKey: QueryKeys.formEntries.mine({ entryID, limit }),
            queryFn: () => getMyFormEntries({ entryID, limit }),
            staleTime: 0,
            ...defaultQueryOptions,
            ...options
        }),
    },
    pathEnrollments: {
        byPathId: ({pathID, options} = {}) => useQuery({
            queryKey: QueryKeys.pathEnrollments.byPathId(pathID),
            queryFn: () => getPathEnrollments(pathID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!pathID,
            ...options
        }),
        byPersonId: ({personID, options} = {}) => useQuery({
            queryKey: QueryKeys.pathEnrollments.byPersonId(personID),
            queryFn: () => getPersonPathEnrollments(personID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!personID,
            ...options
        }),
    },
    emailTemplates: {
        all: (options = {}) => useQuery({
            queryKey: QueryKeys.emailTemplates.all(),
            queryFn: () => getEmailTemplates(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        byId: ({id, options} = {}) => useQuery({
            queryKey: QueryKeys.emailTemplates.byId(id),
            queryFn: () => getEmailTemplate(id),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!id,
            ...options
        }),
    },
    smsCampaigns: {
        all: (options = {}) => useQuery({
            queryKey: QueryKeys.smsCampaigns.all(),
            queryFn: () => getSMSCampaigns(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        recipients: ({ campaignID, options = {} }) => useQuery({
            queryKey: QueryKeys.smsCampaigns.recipients(campaignID),
            queryFn: () => getSMSCampaignRecipients(campaignID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!campaignID,
            ...options
        }),
    },
    emailCampaigns: {
        all: (options = {}) => useQuery({
            queryKey: QueryKeys.emailCampaigns.all(),
            queryFn: () => getEmailCampaigns(),
            staleTime: Infinity,
            ...defaultQueryOptions,
            ...options
        }),
        recipients: ({ campaignID, options = {} }) => useQuery({
            queryKey: QueryKeys.emailCampaigns.recipients(campaignID),
            queryFn: () => getEmailCampaignRecipients(campaignID),
            staleTime: Infinity,
            ...defaultQueryOptions,
            enabled: !!campaignID,
            ...options
        }),
        delivery: ({ campaignID, enabled, options = {} }) => useQuery({
            queryKey: QueryKeys.emailCampaigns.delivery(campaignID),
            queryFn: () => getEmailDeliveryStatuses(campaignID),
            staleTime: 1000 * 60 * 10,
            ...defaultQueryOptions,
            enabled: !!campaignID && !!enabled,
            ...options
        }),
    },
    files: {
        contents: ({ scope, ownerID, folderID, options } = {}) => useQuery({
            queryKey: QueryKeys.files.contents({ scope, ownerID, folderID }),
            queryFn: () => getFolderContents({ folderID, scope, ownerID }),
            ...defaultQueryOptions,
            ...options
        }),
        rootFolder: ({ scope, ownerID, options } = {}) => useQuery({
            queryKey: QueryKeys.files.rootFolder({ scope, ownerID }),
            queryFn: () => getRootFolder({ scope, ownerID }),
            ...defaultQueryOptions,
            ...options
        }),
        tree: ({ scope, ownerID, options } = {}) => useQuery({
            queryKey: QueryKeys.files.tree({ scope, ownerID }),
            queryFn: () => getFolderTree({ scope, ownerID }),
            ...defaultQueryOptions,
            ...options
        }),
        breadcrumbs: ({ folderID, options } = {}) => useQuery({
            queryKey: QueryKeys.files.breadcrumbs({ folderID }),
            queryFn: () => getFolderBreadcrumbs({ folderID }),
            ...defaultQueryOptions,
            enabled: !!folderID,
            ...options
        }),
        storageUsage: ({ options } = {}) => useQuery({
            queryKey: QueryKeys.files.storageUsage(),
            queryFn: () => getOrgStorageUsage(),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            ...options
        }),
        search: ({ query, scope, ownerID, rootFolderID, options } = {}) => useQuery({
            queryKey: QueryKeys.files.search({ query, scope, ownerID, rootFolderID }),
            queryFn: () => searchFiles({ query, scope, ownerID, rootFolderID }),
            ...defaultQueryOptions,
            enabled: !!query && query.length > 0,
            ...options
        }),
    },
    peopleNotes: {
        byPersonId: ({ personID, options } = {}) => useQuery({
            queryKey: QueryKeys.peopleNotes.byPersonId(personID),
            queryFn: () => getNotesByPersonID(personID),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            ...options,
        }),
    },
    giving: {
        merchant: ({ organizationID, options }) => useQuery({
            queryKey: QueryKeys.giving.merchant(organizationID),
            queryFn: () => getGivingMerchant(organizationID),
            enabled: !!organizationID,
            staleTime: 0,
            refetchOnMount: 'always',
            ...options,
        }),
        paymentMethods: ({ organizationID, personID, options }) => useQuery({
            queryKey: QueryKeys.giving.paymentMethods(organizationID, personID),
            queryFn: () => getPaymentMethods({ organizationID, personID }),
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        recurringGifts: ({ organizationID, personID, options }) => useQuery({
            queryKey: QueryKeys.giving.recurringGifts(organizationID, personID),
            queryFn: () => getRecurringGifts({ organizationID, personID }),
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        orgRecurringGifts: ({ organizationID, options }) => useQuery({
            queryKey: QueryKeys.giving.orgRecurringGifts(organizationID),
            queryFn: () => getOrgRecurringGifts({ organizationID }),
            enabled: !!organizationID,
            staleTime: 1000 * 60 * 2,
            ...options,
        }),
        reportSession: ({ organizationID, reportType, options }) => useQuery({
            queryKey: QueryKeys.giving.reportSession(organizationID, reportType),
            queryFn: () => getReportSession(organizationID, reportType),
            enabled: !!organizationID && !!reportType,
            staleTime: 1000 * 60 * 30, // session ttl is 1h; refresh every 30m
            ...options,
        }),
    },
    billing: {
        info: ({ options } = {}) => useQuery({
            queryKey: QueryKeys.billing.info(),
            queryFn: () => getBillingInfo(),
            staleTime: 1000 * 60 * 5,
            ...defaultQueryOptions,
            ...options,
        }),
    },
    milestones: {
        // The catalog changes rarely — safe to cache long; the server catalog
        // remains authoritative for validation (version mismatches fail
        // gracefully in the editor). Sync retry — see retryMilestoneQuery.
        catalog: ({ options } = {}) => useQuery({
            queryKey: QueryKeys.milestones.catalog(),
            queryFn: () => getMilestoneCatalog(),
            staleTime: 1000 * 60 * 30,
            retry: retryMilestoneQuery,
            retryDelay: getRetryDelay,
            enabled: MILESTONES_ENABLED,
            ...options,
        }),
        definitions: ({ organizationID, scope, limit, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.milestones.definitions(organizationID, scope),
            queryFn: ({ pageParam }) => listMilestoneDefinitions({ scope, limit: limit ?? MILESTONE_PRESENTATION.pageSize, after: pageParam }),
            initialPageParam: null,
            retry: retryMilestoneQuery,
            retryDelay: getRetryDelay,
            getNextPageParam: (lastPage) => lastPage?.nextAfter ?? null,
            enabled: MILESTONES_ENABLED && !!organizationID && !!scope,
            ...options,
        }),
        definition: ({ organizationID, milestoneID, options } = {}) => useQuery({
            queryKey: QueryKeys.milestones.definition(organizationID, milestoneID),
            queryFn: () => getMilestoneDefinition(milestoneID),
            staleTime: 1000 * 60 * 5,
            retry: retryMilestoneQuery,
            retryDelay: getRetryDelay,
            enabled: MILESTONES_ENABLED && !!organizationID && !!milestoneID,
            ...options,
        }),
        organizationHistory: ({ organizationID, accountID, limit, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.milestones.organizationHistory(organizationID, accountID),
            queryFn: ({ pageParam }) => getOrganizationMilestoneHistory({ limit: limit ?? MILESTONE_PRESENTATION.pageSize, cursor: pageParam }),
            initialPageParam: null,
            staleTime: 1000 * 60 * 2,
            retry: retryMilestoneQuery,
            retryDelay: getRetryDelay,
            getNextPageParam: (lastPage) => lastPage?.nextCursor ?? null,
            enabled: MILESTONES_ENABLED && !!organizationID && !!accountID,
            ...options,
        }),
        person: ({ organizationID, viewerAccountID, personID, limit, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.milestones.person(organizationID, viewerAccountID, personID),
            queryFn: ({ pageParam }) => getPersonMilestoneState({ personID, limit: limit ?? MILESTONE_PRESENTATION.pageSize, cursor: pageParam }),
            initialPageParam: null,
            staleTime: 1000 * 60 * 2,
            retry: retryMilestoneQuery,
            retryDelay: getRetryDelay,
            getNextPageParam: (lastPage) => lastPage?.nextCursor ?? null,
            enabled: MILESTONES_ENABLED && !!organizationID && !!personID,
            ...options,
        }),
        // Phase E: own pending/celebration presentation state (no claim side effects).
        celebrations: ({ organizationID, accountID, personID, options } = {}) => useQuery({
            queryKey: QueryKeys.milestones.celebrations(organizationID, accountID, personID),
            queryFn: () => getOwnMilestoneCelebrationState(),
            staleTime: 1000 * 30,
            retry: retryMilestoneQuery,
            retryDelay: getRetryDelay,
            enabled: MILESTONES_ENABLED && !!organizationID && !!accountID && !!personID,
            ...options,
        }),
    },
    followUp: {
        // All keys are org-scoped (QueryKeys.followUp); care data is never
        // persisted and is purged on Free downgrade / org switch.
        person: ({ organizationID, personID, touchLimit, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.person(organizationID, personID),
            queryFn: () => getFollowUpPerson(personID, touchLimit),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        myPeople: ({ organizationID, personID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.myPeople(organizationID, personID),
            queryFn: () => getMyFollowUpPeople({ organizationID, personID }),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        personNotes: ({ organizationID, personID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.personNotes(organizationID, personID),
            queryFn: () => getFollowUpPersonNotes(personID),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        personTasks: ({ organizationID, personID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.personTasks(organizationID, personID),
            queryFn: () => getFollowUpPersonTasks({ organizationID, personID }),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        /**
         * Care-context probe for a task instance. Returns the helper-safe
         * follow_up_get_assigned_task projection (+ context personID), or
         * null when the instance is not a care task / not visible to the
         * caller — null is a state, not an error.
         */
        assignedTask: ({ organizationID, taskInstanceID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.assignedTask(organizationID, taskInstanceID),
            queryFn: () => getFollowUpTaskContext(taskInstanceID),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!taskInstanceID,
            ...options,
        }),
        needsOwner: ({ organizationID, limit, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.needsOwner(organizationID),
            queryFn: () => listFollowUpNeedsOwner(limit),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID,
            ...options,
        }),
        /**
         * P5 — Overview: needsAttention (grouped per person), needsOwner,
         * dueWork and recentTouches plus evaluatedAt freshness (spec §6.1).
         * Team-only RPC — call only behind 'View Follow Up'.
         */
        overview: ({ organizationID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.overview(organizationID),
            queryFn: () => getFollowUpOverview(),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID,
            ...options,
        }),
        /**
         * P5 — monitored People list. Server-side filter + cursor pagination;
         * filter is serialized into the key so combinations never share pages.
         * `filter` shape: {caregiverID?, unassigned?, attentionReason?,
         * monitoringMode?, hasWarning?} (empty values stripped by caller).
         */
        people: ({ organizationID, filter, limit, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.followUp.people(organizationID, filter ? JSON.stringify(filter) : 'all'),
            queryFn: ({ pageParam }) => listFollowUpPeople({ filter, cursor: pageParam, limit }),
            initialPageParam: null,
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage) => lastPage?.nextCursor || undefined,
            ...options,
        }),
        /**
         * P5 — My Follow Up: people the caller is primary caregiver for plus
         * tasks assigned to them (spec §6.1 My Follow Up — responsibility vs
         * assignment). Scoped per org AND caller personID.
         */
        my: ({ organizationID, personID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.my(organizationID, personID),
            queryFn: () => getMyFollowUp(),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        audiences: ({ organizationID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.audiences(organizationID),
            queryFn: () => listFollowUpAudiences(),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID,
            ...options,
        }),
        /**
         * P6 — structured Path template list (spec §6.1 Paths). Team-only
         * RPC — call only behind 'View Follow Up'.
         */
        paths: ({ organizationID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.paths(organizationID),
            queryFn: () => listFollowUpPaths(),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID,
            ...options,
        }),
        /**
         * P6 — template detail (live definition + revision for
         * expectedRevision publishing, spec §15.4).
         */
        path: ({ organizationID, pathID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.path(organizationID, pathID),
            queryFn: () => getFollowUpPath(pathID),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!pathID,
            ...options,
        }),
        /**
         * P6 — enrollment list, server-side filter + keyset pagination.
         * `filter` shape: {personID?, pathID?, status?} serialized into the
         * key so combinations never share pages.
         */
        enrollments: ({ organizationID, filter, limit, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.followUp.enrollments(organizationID, filter ? JSON.stringify(filter) : 'all'),
            queryFn: ({ pageParam }) => listFollowUpEnrollments({ filter, cursor: pageParam, limit }),
            initialPageParam: null,
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            getNextPageParam: (lastPage) => lastPage?.nextCursor || undefined,
            ...options,
        }),
        /**
         * P6 — enrollment progress detail (spec §12.5): stages, requirements,
         * evidence attribution, and pending-task review flags.
         */
        enrollment: ({ organizationID, enrollmentID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.enrollment(organizationID, enrollmentID),
            queryFn: () => getFollowUpEnrollment(enrollmentID),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!enrollmentID,
            ...options,
        }),
        /**
         * §25.9 — care episode detail (template-free): episode + caregiver +
         * recent touches + planned tasks + meal slots. Team or the person's
         * primary caregiver server-side.
         */
        careEpisode: ({ organizationID, careEpisodeID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.careEpisode(organizationID, careEpisodeID),
            queryFn: () => getFollowUpCareEpisode(careEpisodeID),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!careEpisodeID,
            ...options,
        }),
        /**
         * §25.9 — permission-scoped active-care summary list (the Dashboard
         * "Active care" section and care rosters). Server-side status
         * filter + keyset pagination; `filter` shape {status?} serializes
         * into the key so combinations never share pages.
         */
        careEpisodes: ({ organizationID, status, limit, options } = {}) => useInfiniteQuery({
            queryKey: QueryKeys.followUp.careEpisodes(organizationID, status || 'all'),
            queryFn: ({ pageParam }) => listFollowUpCareEpisodes({ status, cursor: pageParam, limit }),
            initialPageParam: null,
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID,
            getNextPageParam: (lastPage) => lastPage?.nextCursor || undefined,
            ...options,
        }),
        /**
         * §25.9 — a person's ACTIVE care episode for the person Follow Up
         * surface (RLS: team or primary caregiver; null = no active care).
         */
        personCareEpisode: ({ organizationID, personID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.careEpisodes(organizationID, `person:${personID}`),
            queryFn: () => getFollowUpPersonActiveCareEpisode({ organizationID, personID }),
            staleTime: 1000 * 60 * 2,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!personID,
            ...options,
        }),
        /**
         * Close-care pending-work preview (spec §13.6/§25.9): the RPC with
         * preview:true never mutates. Refetched fresh whenever the sheet
         * opens so the keep/cancel decisions address current state.
         */
        careClosePreview: ({ organizationID, careEpisodeID, options } = {}) => useQuery({
            queryKey: QueryKeys.followUp.careClosePreview(organizationID, careEpisodeID),
            queryFn: () => closeFollowUpCare({ careEpisodeID, preview: true }),
            staleTime: 0,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!careEpisodeID,
            ...options,
        }),
    },
    serviceFlows: {
        /**
         * v2 template library page — scoped by organization + account, ~30s
         * staleness (spec §12.5). Enabled by the caller's v2 availability check.
         */
        templates: ({ organizationID, accountID, archived = false, search = '', page = 0, options } = {}) => useQuery({
            queryKey: QueryKeys.serviceFlows.templates(organizationID, accountID, { archived, search, page }),
            queryFn: () => getServiceFlowTemplates({ archived, search, page }),
            staleTime: SERVICE_FLOW_STALE_TIME,
            placeholderData: keepPreviousData,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!accountID,
            ...options,
        }),
        template: ({ organizationID, accountID, templateID, options } = {}) => useQuery({
            queryKey: QueryKeys.serviceFlows.template(organizationID, accountID, templateID),
            queryFn: () => getServiceFlowTemplate(templateID),
            staleTime: SERVICE_FLOW_STALE_TIME,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!accountID && !!templateID,
            ...options,
        }),
        eventAttachment: ({ organizationID, accountID, eventID, options } = {}) => useQuery({
            queryKey: QueryKeys.serviceFlows.event(organizationID, accountID, eventID),
            queryFn: () => getEventServiceFlowAttachment(eventID),
            staleTime: SERVICE_FLOW_STALE_TIME,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!accountID && !!eventID,
            ...options,
        }),
        instance: ({ organizationID, accountID, eventInstanceID, locationID = null, options } = {}) => useQuery({
            queryKey: QueryKeys.serviceFlows.instance(organizationID, accountID, eventInstanceID, locationID),
            queryFn: () => getServiceFlowInstance(eventInstanceID, locationID),
            staleTime: SERVICE_FLOW_STALE_TIME,
            ...defaultQueryOptions,
            enabled: !!organizationID && !!accountID && !!eventInstanceID,
            ...options,
        }),
        // Legacy v1 read — only mounted for pre-cutover organizations (read-only).
        byInstance: ({ eventInstanceID, options } = {}) => useQuery({
            queryKey: QueryKeys.serviceFlows.byInstance(eventInstanceID),
            queryFn: () => getServiceFlowForInstance(eventInstanceID),
            staleTime: SERVICE_FLOW_STALE_TIME,
            ...defaultQueryOptions,
            enabled: !!eventInstanceID,
            ...options,
        }),
    },
}


const tasksByDueType = (dueType, options) => {
    if(dueType){; 
        const dueTypes = Array.isArray(dueType) ? dueType : [dueType];
        const queryOptions = { staleTime: Infinity, 
            ...defaultQueryOptions, initialData: () => {
            return queryClient.getQueryData(QueryKeys.tasks.all())?.filter((t) => dueTypes.includes(t.dueType))
        }, 
            ...options}

        return useQuery({
            queryKey: QueryKeys.tasks.byDueType(dueType), 
            queryFn: () => getTasks(dueType), 
            ...queryOptions
        });
    }
}